import React from 'react';
import { ObdMilestonesGrid, useStandardMilestoneCards } from './obdMilestonesShared';

export type DashboardV3MilestonesRowProps = {
    theme: 'dark' | 'light';
    opportunityNumericId: string | number | null;
    salesForceId?: string | null;
};

export const DashboardV3MilestonesRow: React.FC<DashboardV3MilestonesRowProps> = ({
    theme,
    opportunityNumericId,
    salesForceId,
}) => {
    const cards = useStandardMilestoneCards({ opportunityNumericId, salesForceId });
    return <ObdMilestonesGrid theme={theme} cards={cards} />;
};
